/**
 * 门户边框默认配置数据
 */
export const home = [{}]

/**
 * 大屏边框默认配置数据
 */
export const bs = [
  {},
  // {
  //   isOnlinelRes: true,
  //   imgSrc: "/sv2/assets/test.gif",
  //   previewSrc: "/sv2/assets/test.gif"
  // },
  {
    styleId:2,
    imgSrc: "blue_animate1.png",
    previewSrc: "blue_animate1.png"
  },
  {
    styleId:3,
    imgSrc: "blue_animate2.png",
    previewSrc: "blue_animate2.png"
  },
  {
    styleId:4,
    imgSrc: "blue_animate3.png",
    previewSrc: "blue_animate3.png"
  },
  {
    styleId:5,
    imgSrc: "blue_animate4.png",
    previewSrc: "blue_animate4.png"
  },
  {
    styleId:6,
    imgSrc: "blue_animate5.png",
    previewSrc: "blue_animate5.png"
  },
  {
    styleId:7,
    imgSrc: "blue_animate6.png",
    previewSrc: "blue_animate6.png"
  },
  {
    styleId:8,
    imgSrc: "blue_animate7.png",
    previewSrc: "blue_animate7.png"
  },
  {
    styleId:9,
    imgSrc: "green_animate1.png",
    previewSrc: "green_animate1.png"
  },
  {
    styleId:10,
    imgSrc: "green_animate2.png",
    previewSrc: "green_animate2.png"
  },
  {
    styleId:11,
    imgSrc: "green_animate3.png",
    previewSrc: "green_animate3.png"
  },
  {
    styleId:12,
    imgSrc: "green_animate4.png",
    previewSrc: "green_animate4.png"
  },
  {
    styleId:13,
    imgSrc: "green_animate5.png",
    previewSrc: "green_animate5.png"
  },
  {
    styleId:14,
    imgSrc: "green_animate6.png",
    previewSrc: "green_animate6.png"
  },
  {
    styleId:15,
    imgSrc: "green_animate7.png",
    previewSrc: "green_animate7.png"
  },
  {
    styleId:16,
    imgSrc: "purple_animate1.png",
    previewSrc: "purple_animate1.png"
  },
  {
    styleId:17,
    imgSrc: "purple_animate2.png",
    previewSrc: "purple_animate2.png"
  },
  {
    styleId:18,
    imgSrc: "purple_animate3.png",
    previewSrc: "purple_animate3.png"
  },
  {
    styleId:19,
    imgSrc: "warm_animate1.png",
    previewSrc: "warm_animate1.png"
  },
  {
    styleId:20,
    imgSrc: "warm_animate2.png",
    previewSrc: "warm_animate2.png"
  },
  {
    styleId:21,
    imgSrc: "warm_animate3.png",
    previewSrc: "warm_animate3.png"
  },
  {
    styleId:22,
    imgSrc: "warm_animate4.png",
    previewSrc: "warm_animate4.png"
  },
  {
    styleId:23,
    imgSrc: "warm_animate5.png",
    previewSrc: "warm_animate5.png"
  },
  {
    styleId:24,
    imgSrc: "warm_animate6.png",
    previewSrc: "warm_animate6.png"
  },
  {
    styleId:25,
    imgSrc: "white_animate1.png",
    previewSrc: "white_animate1.png"
  },
  {
    styleId:26,
    imgSrc: "white_animate2.png",
    previewSrc: "white_animate2.png"
  },
  {
    styleId:27,
    imgSrc: "white_animate3.png",
    previewSrc: "white_animate3.png"
  },
  {
    styleId:28,
    imgSrc: "white_animate4.png",
    previewSrc: "white_animate4.png"
  }
]

/**
 * app边框默认配置数据
 */
export const appHome = [{}]
